var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.586 2A2 2 0 0 1 13 2.586l9 9a2 2 0 0 1 0 2.828L14.414 22a2 2 0 0 1-2.828 0l-9-9A2 2 0 0 1 2 11.586V3a1 1 0 0 1 1-1zm0 2H4v7.586l9 9L20.586 13zM7 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }